import LaporanHPPApi from "./LaporanHPPApi";

export default LaporanHPPApi;
